import { create } from 'zustand';

import { checkIfValidFilter } from 'MODULES/universal-filters/utils/checkifValidFilterConfig';
import { FilterExpression } from 'MODULES/universal-filters/utils/types';
import { FilterConfig } from 'SRC/fetch/api/observability';

type UniversalFiltersConfig = {
  paramsInitialized: boolean;
  filtersConfig: Map<string, FilterConfig>;
  quickFilters: Map<string, FilterConfig>;
  setFilters: (data: FilterConfig[]) => void;
  parsedKeys: Set<string>;
  universalFilters: Map<string, FilterExpression>;
  resetParamsState: () => void;
  setParamsInitialized: () => void;
};

export const universalFiltersConfig = create<UniversalFiltersConfig>(
  (set, get) => ({
    paramsInitialized: false,
    setParamsInitialized: () => {
      if (get().paramsInitialized) {
        return;
      }
      set(() => ({ paramsInitialized: true }));
    },
    filtersConfig: new Map(),
    quickFilters: new Map(),

    setFilters: (filterConfigs) => {
      const filtersConfig: Map<string, FilterConfig> = new Map();
      const quickFilters: Map<string, FilterConfig> = new Map();

      filterConfigs.forEach((filter) => {
        if (checkIfValidFilter(filter)) {
          if (filter.isQuickFilter) {
            quickFilters.set(filter.key, filter);
          }
          filtersConfig.set(filter.key, filter);
        }
      });
      set(() => ({ filtersConfig, quickFilters }));
    },

    parsedKeys: new Set(),
    universalFilters: new Map(),
    resetParamsState: () =>
      set(() => ({
        parsedKeys: new Set(),
        universalFilter: new Map(),
      })),
  }),
);
